(function () {
  if (window.__cmx) return;
  window.__cmx = 1;
  var d = document, K = 'cm_wish';
  function wl() { try { return JSON.parse(localStorage.getItem(K) || '[]'); } catch (e) { return []; } }
  function mark() {
    var a = wl();
    [].forEach.call(d.querySelectorAll('.cmx-wish'), function (w) { w.classList.toggle('is-on', a.indexOf(w.getAttribute('data-wish')) > -1); });
  }
  function openCart() {
    var c = d.querySelector('.cm-hd__cart');
    if (c) { c.click(); } else { window.location.href = '/cart'; }
  }
  /* Touch screens: load the second image early so the swipe never shows a blank frame */
  var io = null;
  function prime() {
    if (!window.matchMedia || !window.matchMedia('(max-width:989px),(hover:none)').matches || !('IntersectionObserver' in window)) return;
    if (!io) {
      io = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (!en.isIntersecting) return;
          var im = en.target.querySelector('.cmx-img--2');
          if (im) im.loading = 'eager';
          io.unobserve(en.target);
        });
      }, { rootMargin: '400px' });
    }
    [].forEach.call(d.querySelectorAll('.cmx-card.has-2 .cmx-media'), function (m) { io.observe(m); });
  }
  /* Keep the dots in sync with the swipe position (scroll does not bubble, so listen in capture) */
  d.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!t || !t.classList || !t.classList.contains('cmx-link')) return;
    var dots = t.parentNode.querySelector('.cmx-dots');
    if (!dots) return;
    var i = Math.round(Math.abs(t.scrollLeft) / Math.max(1, t.clientWidth));
    [].forEach.call(dots.children, function (x, k) { x.classList.toggle('on', k === i); });
  }, true);
  d.addEventListener('click', function (e) {
    var q = e.target.closest('.cmx-qty button');
    if (q) {
      e.preventDefault();
      var n = q.parentNode.querySelector('b'), v = parseInt(n.textContent, 10) || 1;
      v += q.getAttribute('data-d') === '+' ? 1 : -1;
      n.textContent = Math.min(99, Math.max(1, v));
      return;
    }
    var w = e.target.closest('.cmx-wish');
    if (w) {
      e.preventDefault();
      var a = wl(), h = w.getAttribute('data-wish'), i = a.indexOf(h);
      if (i > -1) a.splice(i, 1); else a.push(h);
      try { localStorage.setItem(K, JSON.stringify(a)); } catch (x) {}
      mark();
      return;
    }
    var b = e.target.closest('button.cmx-add');
    if (b && !b.classList.contains('is-off')) {
      var card = b.closest('.cmx-card');
      var scope = b.closest('.cmx-ov, .cmx-ctl') || card;
      var qn = scope.querySelector('.cmx-qty b');
      var qty = qn ? (parseInt(qn.textContent, 10) || 1) : 1;
      b.classList.add('is-loading');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(card.getAttribute('data-id')), quantity: qty }] })
      })
        .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'error'); }); return r.json(); })
        .then(function () {
          b.classList.remove('is-loading');
          b.classList.add('is-done');
          setTimeout(function () { b.classList.remove('is-done'); }, 1800);
          openCart();
        })
        .catch(function () {
          b.classList.remove('is-loading');
          b.classList.add('is-err');
          setTimeout(function () { b.classList.remove('is-err'); }, 2000);
        });
    }
  });
  function init() { mark(); prime(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
  d.addEventListener('shopify:section:load', init);
})();
